// Shared cache constants + helpers for the query hooks.
//
// staleTime tiers:
//  - ONE_HOUR  → reference data (categories, mediums, …) that rarely changes.
//  - AD_STALE  → live auction data (prices, bid counts, open/closed state).
//  - DASH_STALE→ the user's own dashboard data, refreshed via mutation
//    invalidation; the short window just dedupes tab switches.
export const ONE_HOUR = 60 * 60 * 1000;
export const AD_STALE = 30 * 1000;
export const DASH_STALE = 30 * 1000;

// Shape of the paginated ad-search responses ({ ads, more }).
export type AdsPage = { ads: any[]; more: boolean };

// Push any "Other"/"Others" entry to the end while keeping the rest in their
// original (stable) order. Used by the category/medium/sub-category dropdowns
// so they don't each re-implement it. `nameOf` lets callers point at a nested
// name field.
export const sortOthersLast = <T>(
  arr: T[] = [],
  nameOf: (x: T) => string = (x: any) => x?.name,
): T[] => {
  const isOther = (n: string) => {
    const t = (n || "").trim().toLowerCase();
    return t === "other" || t === "others";
  };
  return [...arr].sort(
    (a, b) => Number(isOther(nameOf(a))) - Number(isOther(nameOf(b))),
  );
};
